import { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';

const CashSessionOpen = ({ show, onClose, onSubmit, cashRegister }) => {
  const [formData, setFormData] = useState({
    monto_inicial: '30.00',
    observaciones: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.monto_inicial || parseFloat(formData.monto_inicial) < 0) {
      setError('El monto inicial debe ser mayor o igual a 0');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const result = await onSubmit({
        monto_inicial: parseFloat(formData.monto_inicial),
        observaciones: formData.observaciones,
      });

      if (!result.success) {
        setError(result.message || 'Error al abrir la sesión');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error al abrir la sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-door-open me-2"></i>
          Abrir Caja
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && (
            <Alert variant="danger" dismissible onClose={() => setError(null)}>
              {error}
            </Alert>
          )}

          <div className="mb-3">
            <p className="mb-2">
              <strong>Caja:</strong> {cashRegister?.nombre}
            </p>
            <p className="mb-0">
              <strong>Punto de Venta:</strong> {cashRegister?.punto_venta?.nombre}
            </p>
          </div>

          <hr />

          <Form.Group className="mb-3">
            <Form.Label>
              Monto Inicial en Efectivo <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="monto_inicial"
              value={formData.monto_inicial}
              onChange={handleChange}
              placeholder="0.00"
              required
              autoFocus
            />
            <Form.Text className="text-muted">
              Cantidad de efectivo con la que inicia la caja
            </Form.Text>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Observaciones</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="observaciones"
              value={formData.observaciones}
              onChange={handleChange}
              placeholder="Notas sobre la apertura (opcional)"
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Abriendo...
              </>
            ) : (
              <>
                <i className="bi bi-check-circle me-2"></i>
                Abrir Caja
              </>
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CashSessionOpen;